
import { Controller } from "@hotwired/stimulus"
import { createRoot } from 'react-dom/client'
import React from 'react';
export default class extends Controller {
  static values = { component: String }
  

  connect() {
    this.root = null;
    this.initializeReact()
  }

  disconnect() {
    this.cleanupReact()
  }

  async initializeReact() {
    if (!this.root) {
      const importedModule = await import('../components/index');
      console.log("Imported module keys:", Object.keys(importedModule));
      const Component = importedModule[this.componentValue];
  
      if (!Component) {
        console.error(`Component "${this.componentValue}" not found in imported module.`);
        return;
      }
        
      const container = document.createElement('div')
      container.className = 'react-container'
      this.element.appendChild(container)
        
      this.root = createRoot(container)
      this.root.render(<Component />)
    }
  }

  cleanupReact() {
    if (this.root) {
      this.root.unmount()
      this.element.querySelector('.react-container')?.remove()
      this.root = null
    }
  }
}